import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { PageRequestError } from "components/PageRequestError";
import { ProgressSpinner } from "primereact/progressspinner";
import { Title } from "components/Title";
import useApp from "hooks/useApp";

import useEditPage from "hooks/useEditPage";
import { MultiSelect } from "primereact/multiselect";
import { useEffect, useState } from "react";
const RolesEditPage = (props) => {
  const app = useApp();
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  // form validation schema
  const validationSchema = yup.object().shape({
    name: yup.string().required().label("Name"),
    permissions: yup.array().required().label("Permissions"),
  });
  // form default values
  const formDefaultValues = {
    name: "",
    permissions: [],
  };
  //where page logics resides
  const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
  //destructure and grab what we need
  const {
    formData,
    handleSubmit,
    submitForm,
    pageReady,
    loading,
    saving,
    apiRequestError,
    inputClassName,
  } = pageController;

  useEffect(() => {
    if (formData && formData.permissions) {
      const permissionArray = formData.permissions.map((permission) => {
        const obj = { name: permission.name };
        return obj;
      });
      setSelectedPermissions(permissionArray);
    }
  }, [formData]);
  //Event raised on form submit success
  function afterSubmit(response) {
    app.flashMsg(props.msgTitle, props.msgAfterSave);
    if (app.isDialogOpen()) {
      app.closeDialogs(); // if page is open as dialog, close dialog
    } else if (props.redirect) {
      app.navigate(`/roles`);
    }
  }
  // loading form data from api
  if (loading) {
    return (
      <div className="p-3 text-center">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
      </div>
    );
  }
  //display error page
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }

  const handlePermissionChange = (event) => {
    setSelectedPermissions(event.value); // Update permissions state
  };
  // permission options
  const permissions = [
    { name: "admin" },
    { name: "user" },
    { name: "doctor" },
    { name: "nurse" },
    { name: "pharmacist" },
  ];
  //page is ready when formdata loaded successfully
  if (pageReady) {
    return (
      <main id="UsersEditPage" className="main-page">
        {props.showHeader && (
          <section className="page-section mb-3">
            <div className="container">
              <div className="grid align-items-center">
                {!props.isSubPage && (
                  <div className="col-fixed ">
                    <Button
                      onClick={() => app.navigate(-1)}
                      label=""
                      className="p-button p-button-text "
                      icon="pi pi-arrow-left"
                    />
                  </div>
                )}
                <div className="col ">
                  <Title
                    title="Edit Role"
                    titleClass="text-2xl text-primary font-bold"
                    subTitleClass="text-500"
                    separator={false}
                  />
                </div>
              </div>
            </div>
          </section>
        )}
        <section className="page-section ">
          <div className="container">
            <div className="grid ">
              <div className="md:col-9 sm:col-12 comp-grid">
                <div>
                  <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => {
                      const formData = {
                        name: values.name,
                        permissions: selectedPermissions.map(
                          (permission) => permission.name
                        ),
                      };
                      submitForm(formData);
                    }}
                  >
                    {(formik) => {
                      return (
                        <Form className={`${!props.isSubPage ? "card  " : ""}`}>
                          <div className="grid">
                            <div className="col-12">
                              <div className="formgrid grid">
                                <div className="col-12 md:col-3">Id</div>
                                <div className="col-12 md:col-9">
                                  <InputText
                                    name="id"
                                    disabled
                                    onChange={formik.handleChange}
                                    value={formik.values.id}
                                    label="Id"
                                    type="number"
                                    placeholder="Enter Id"
                                    min={0}
                                    step="any"
                                    className={inputClassName(
                                      formik?.errors?.id
                                    )}
                                  />
                                  <ErrorMessage
                                    name="id"
                                    component="span"
                                    className="p-error"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="formgrid grid">
                                <div className="col-12 md:col-3">Name</div>
                                <div className="col-12 md:col-9">
                                  <InputText
                                    name="name"
                                    onChange={formik.handleChange}
                                    value={formik.values.name}
                                    label="Name"
                                    type="text"
                                    placeholder="Enter Name"
                                    className={inputClassName(
                                      formik?.errors?.name
                                    )}
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="span"
                                    className="p-error"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="formgrid grid">
                                <div className="col-12 md:col-3">
                                  Permissions
                                </div>
                                <div className="col-12 md:col-9">
                                  <MultiSelect
                                    name="permissions"
                                    value={selectedPermissions}
                                    onChange={handlePermissionChange}
                                    options={permissions}
                                    optionLabel="name"
                                    display="chip"
                                    placeholder="Select Permissions"
                                    maxSelectedLabels={5}
                                    className={inputClassName(
                                      formik?.errors?.permissions
                                    )}
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="span"
                                    className="p-error"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {props.showFooter && (
                            <div className="text-center my-3">
                              <Button
                                onClick={(e) => handleSubmit(e, formik)}
                                type="submit"
                                label="Update"
                                icon="pi pi-send"
                                loading={saving}
                              />
                            </div>
                          )}
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
};
RolesEditPage.defaultProps = {
  primaryKey: "id",
  pageName: "roles",
  getApiPath: "roles/get_role",
  putApiPath: "roles/edit_role",
  routeName: "rolesedit",
  submitButtonLabel: "Update",
  formValidationError: "Form is invalid",
  formValidationMsg: "Please complete the form",
  msgTitle: "Update Record",
  msgAfterSave: "Record updated successfully",
  msgBeforeSave: "",
  showHeader: true,
  showFooter: true,
  redirect: true,
  isSubPage: false,
};
export default RolesEditPage;
